// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RYqr","col":"styles_col__kpadZ"};